export default __webpack_public_path__ + "static/media/navigator.ecaaf557.png";